module.exports.skipListMessages = (path, params) => {
  const splited = path.split('/').filter(item => item.trim() != '');
  return splited[splited.length - 1] == 'edit' && params && params.type == 'messagesToApprove';
}